import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObj: {
    SheetNo: 0,
    Loc: "",
    LocName: "",
    Date: new Date(),
    ReferenceNo: "",
    A_DocStat: "ENTER",
    PoType: "",
    POTypeName: "",
    PoNo: "",
    PDTUserCode: "",
    PDTUserName: "",
  },
  SummaryObj: {
    loc: "",
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
  },
};

const SliceWmsPoPhysicalStockCount = createSlice({
  name: "SliceWmsPoPhysicalStockCount",
  initialState: { value: initialState },

  reducers: {
    Set_SliceWmsPoPhysicalStockCount_HeadObj: (state, action) => {
      state.value.HeadObj = action.payload;
    },
    Set_SliceWmsPoPhysicalStockCount_HeadObj_Init: (state, action) => {
      state.value.HeadObj = initialState.HeadObj;
    },

    Set_SliceWmsPoPhysicalStockCount_SummaryObj: (state, action) => {
      state.value.SummaryObj = action.payload;
    },
    SliceWmsPoPhysicalStockCount_Init: (state) => {
      state.value = initialState;
    },

    Set_SliceWmsPoPhysicalStockCount_HeadObj_New_Set: (state, action) => {
      state.value.HeadObj.SheetNo = action.payload.SheetNo;
      state.value.HeadObj.Loc = action.payload.Loc;
      state.value.HeadObj.Date = action.payload.Date;
      state.value.HeadObj.ReferenceNo = action.payload.ReferenceNo;
    },
    Set_SliceWmsPoPhysicalStockCount_HeadObject_A_DocStat: (state, action) => {
      state.value.HeadObj.A_DocStat = action.payload.A_DocStat;
    },
    Set_SliceWmsPoPhysicalStockCount_HeadObject_SheetNo_A_DocStat: (
      state,
      action
    ) => {
      state.value.HeadObj.SheetNo = action.payload.SheetNo;
      state.value.HeadObj.A_DocStat = action.payload.A_DocStat;
    },
  },
});

export const {
  Set_SliceWmsPoPhysicalStockCount_HeadObj,
  Set_SliceWmsPoPhysicalStockCount_SummaryObj,
  Set_SliceWmsPoPhysicalStockCount_HeadObject_A_DocStat,
  Set_SliceWmsPoPhysicalStockCount_HeadObject_SheetNo_A_DocStat,
  SliceWmsPoPhysicalStockCount_Init,
  Set_SliceWmsPoPhysicalStockCount_HeadObj_Init,
  Set_SliceWmsPoPhysicalStockCount_HeadObj_New_Set,
} = SliceWmsPoPhysicalStockCount.actions;
export default SliceWmsPoPhysicalStockCount.reducer;
